import { render, staticRenderFns } from "./newUserDetailed.vue?vue&type=template&id=b03742b0&scoped=true&"
import script from "./newUserDetailed.vue?vue&type=script&lang=js&"
export * from "./newUserDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03742b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b03742b0')) {
      api.createRecord('b03742b0', component.options)
    } else {
      api.reload('b03742b0', component.options)
    }
    module.hot.accept("./newUserDetailed.vue?vue&type=template&id=b03742b0&scoped=true&", function () {
      api.rerender('b03742b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dataManage/newUserDetailed/newUserDetailed.vue"
export default component.exports